var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-navigation',{attrs:{"isScrolled":_vm.isScrolled,"introActive":_vm.introActive,"workActive":_vm.workActive,"aboutActive":_vm.aboutActive}}),_c('app-intro'),_c('app-work'),_c('app-about')],1)}
var staticRenderFns = []

export { render, staticRenderFns }